"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTextTags = removeTextTags;

function removeTextTags(originalText) {
  if (typeof originalText !== 'string') {
    return '';
  }

  var regex = /\[\/?(\*|b|i|h|list|quote|url(=?.*?))\]/g;
  return originalText.replace(regex, '');
}